import { HTMLProps } from 'react';
import { U21Themes } from 'vendor/material-minimal/models';

import { getDOMProps } from 'app/shared/utils/react';
import { useTheme } from '@mui/material/styles';

import EquifaxLogoLightMode from 'app/shared/components/logos/equifaxLogoLightMode.svg';
import EquifaxLogoDarkMode from 'app/shared/components/logos/equifaxLogoDarkMode.svg';
import LogoLightMode from 'app/shared/components/logos/logoLightMode.svg';
import LogoDarkMode from 'app/shared/components/logos/logoDarkMode.svg';
import { useSelector } from 'react-redux';
import { selectEquifaxDemoEnabled } from 'app/shared/featureFlags/selectors';

export const Unit21Logo = (props: HTMLProps<SVGElement>) => {
  const {
    palette: { mode },
  } = useTheme();
  const equifaxDemoEnabled = useSelector(selectEquifaxDemoEnabled);
  if (equifaxDemoEnabled) {
    const Logo =
      mode === U21Themes.LIGHT ? EquifaxLogoLightMode : EquifaxLogoDarkMode;
    return <Logo alt="Logo" {...getDOMProps(props)} />;
  }
  const Logo = mode === U21Themes.LIGHT ? LogoLightMode : LogoDarkMode;
  return <Logo alt="Logo" {...getDOMProps(props)} />;
};
